module.exports = __webpack_public_path__ + "src/assets/games/43/18.jpg";